class ResultsSlider extends HTMLElement {
  constructor() {
    super();

    this.initializeEmbla = this.initializeEmbla.bind(this);
    this.clearActiveNavButtons = this.clearActiveNavButtons.bind(this);
  }

  connectedCallback() {
    this.emblaNode = this.querySelector('.embla');
    this.slideNodes = this.querySelectorAll('.embla__slide');
    this.slideNavButtons = this.querySelectorAll('.slider-nav button');

    this.initializeEmbla();
  }

  clearActiveNavButtons() {
    this.slideNavButtons.forEach((button) => {
      button.classList.remove('active');
    });
  }

  initializeEmbla() {
    if (this.emblaNode) {
      let plugins = [];

      plugins.push(EmblaCarouselFade());

      const emblaApi = EmblaCarousel(this.emblaNode, {}, plugins);

      const clearActiveNavButtons = this.clearActiveNavButtons;
      this.slideNavButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          clearActiveNavButtons();
          button.classList.add('active');
          emblaApi.scrollTo(index);
        });
      });
    }
  }
}

customElements.define('results-slider', ResultsSlider);
